<template>
	<div class="container products-details">
		<div class="main-banner">
			<img src="@/assets/img/products-banner.jpg" alt="" class="banner-img" />
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<img src="@/assets/img/icon10.png" alt="" class="img" />
				<el-breadcrumb-item :to="{ path: '/' }">HOME</el-breadcrumb-item>
				<el-breadcrumb-item>Productor</el-breadcrumb-item>
				<el-breadcrumb-item>detailed information</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="row">
			<div class="col-xs-12 col-sm-3 hidden-xs wow fadeInLeft">
				<!--        <ul class="nav-left">-->
				<!--          <li-->
				<!--            class="nav-left-li"-->
				<!--            :class="{ active: navId == item.id }"-->
				<!--            v-for="item in navList"-->
				<!--            :key="item.id"-->
				<!--            @click="navItemClick(item)"-->
				<!--          >-->
				<!--            <span class="line1" title="FAW TRACTOR TRUCK"-->
				<!--              >FAW TRACTOR TRUCK</span-->
				<!--            ><i class="iconfont">&#xe793;</i>-->
				<!--          </li>-->
				<!--        </ul>-->
				<div class="contact-left">
					<img src="@/assets/img/contact-left.jpg" class="contact-left-banner" />
					<ul class="contact-left-info">
						<li>
							<img src="@/assets/img/icon05.png" alt="email" title="email" /><span>BaodaGroup@126.com</span>
						</li>
						<li>
							<img src="@/assets/img/icon07.png" alt="WhatsApp" title="WhatsApp" /><span>+8615212345678</span>
						</li>
						<li>
							<img src="@/assets/img/icon08.png" alt="mobile phone" title="mobile phone" /><span>+8615212345678</span>
						</li>
						<li>
							<div class="col-xs-6">
								<p><img src="@/assets/img/QRcode.png" /></p>
								<img src="@/assets/img/icon11.png" /><span>WeChat</span>
							</div>
							<div class="col-xs-6">
								<p><img src="@/assets/img/QRcode.png" /></p>
								<img src="@/assets/img/icon12.png" /><span>QQ</span>
							</div>
						</li>
					</ul>
				</div>
			</div>
			<div class="col-xs-12 col-sm-9 wow fadeInRight">
				<div class="carousel-thumbnail-wrapper">
					<el-carousel class="carousel-thumbnail" :interval="6000" indicator-position="none" @change="carouselChange"
						ref="carousel">
						<el-carousel-item v-for="(item,index) in vehicleInfo.urls" :key="index">
							<el-image :src="item" :preview-src-list="vehicleInfo.urls" fit="fill">
							</el-image>
						</el-carousel-item>
					</el-carousel>
					<div class="xiaotu">
						<div class="xiaotu-img" :class="xiaotuIndex==index?'active':''" v-for="(item,index) in vehicleInfo.urls"
							:key="index" @click="xiaotuImg(index)">
							<img :src="item" />
						</div>
					</div>
				</div>
				<!-- <el-image class="products-details-banner" :src="vehicleInfo.urls !==null?vehicleInfo.urls[0]:''"
					fit="fill"></el-image> -->
				<div class="products-title">Vehicle Overview</div>
				<ul class="products-info">
					<li class="w100">
						<div class="title"><span>车 型</span><em>：</em></div>
						<div class="content">
							{{ vehicleInfo.number }}
						</div>
					</li>
					<li>
						<div class="title"><span>主要参数</span><em>：</em></div>
						<div class="content">{{ vehicleInfo.parameter }}</div>
					</li>
					<!--          <li class="w50">-->
					<!--            <div class="title"><span>动力类型</span><em>：</em></div>-->
					<!--            <div class="content">柴油</div>-->
					<!--          </li>-->
					<!--          <li class="w50">-->
					<!--            <div class="title"><span>驾驶室</span><em>：</em></div>-->
					<!--            <div class="content">虎VH平顶单排驾驶室</div>-->
					<!--          </li>-->
					<!--          <li class="w50">-->
					<!--            <div class="title"><span>载 重</span><em>：</em></div>-->
					<!--            <div class="content">6T</div>-->
					<!--          </li>-->
					<!--          <li class="w50">-->
					<!--            <div class="title"><span>速 比</span><em>：</em></div>-->
					<!--            <div class="content">4.875</div>-->
					<!--          </li>-->
					<!--          <li class="w50">-->
					<!--            <div class="title"><span>轮 距</span><em>：</em></div>-->
					<!--            <div class="content">1740mm</div>-->
					<!--          </li>-->
					<!--          <li class="w50">-->
					<!--            <div class="title"><span>底 盘</span><em>：</em></div>-->
					<!--            <div class="content">康机ISF3.8s5154,6G55,Ф350,7B9,340冲焊桥</div>-->
					<!--          </li>-->
					<!--          <li class="w50">-->
					<!--            <div class="title"><span>油 箱</span><em>：</em></div>-->
					<!--            <div class="content">100L</div>-->
					<!--          </li>-->
					<!--          <li class="w50">-->
					<!--            <div class="title"><span>轮 胎</span><em>：</em></div>-->
					<!--            <div class="content">235/75R17.5</div>-->
					<!--          </li>-->
					<!--          <li class="w50">-->
					<!--            <div class="title"><span>载货尺寸</span><em>：</em></div>-->
					<!--            <div class="content">1.9m（long）*6m（wide）*1.9m（high）</div>-->
					<!--          </li>-->
					<!--          <li class="w50">-->
					<!--            <div class="title"><span>车辆尺寸</span><em>：</em></div>-->
					<!--            <div class="content">2m（long）*8m（wide）*2.5m（high）</div>-->
					<!--          </li>-->
					<li class="w100">
						<div class="title"><span>其 他</span><em>：</em></div>
						<div class="content">
							{{ vehicleInfo.basicConfiguration }}
						</div>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				xiaotuIndex: '0',
				token: localStorage.getItem('token'),
				bannerUrl: require("@/assets/img/products-img03.jpg"),
				navId: 1,
				vehicleInfo: {},
				navList: [{
						id: 1,
						name: "FAW TRACTOR TRUCK",
					},
					{
						id: 2,
						name: "FAW DUMP TRUCK",
					},
					{
						id: 3,
						name: "FAW CARGO TRUCK",
					},
					{
						id: 4,
						name: "FAW SPECIAL TRUCK",
					},
					{
						id: 5,
						name: "FAW LIGHT TRUCK",
					},
				],
			};
		},
		watch: {
			$route: {
				handler() {
					// if (!this.token) {
					//   this.$message({
					//     message: 'please log in first！',
					//     type: 'warning'
					//   });
					//   this.$router.push('/')
					// }
					this.vehicleInfo = JSON.parse(this.$route.query.vehicleInfo)
				},
				immediate: false,
				deep: false
			}
		},
		created() {
			// if (!this.token) {
			//   this.$router.push('/')
			// }
			this.vehicleInfo = JSON.parse(this.$route.query.vehicleInfo)
		},
		methods: {
			carouselChange(index) {
				this.xiaotuIndex = index
			},
			xiaotuImg(index) {
				this.xiaotuIndex = index
				this.$refs.carousel.setActiveItem(index)
			},
			navItemClick(item) {
				this.navId = item.id;
			},
		},
	};
</script>

<style lang="scss" scoped>
	::v-deep.carousel-thumbnail-wrapper {
		display: flex;
		justify-content: space-between;
		margin: 0 0 20px 0;
		.carousel-thumbnail {
			height: 420px;
			width: 80%;
	
			.el-carousel__container {
				height: 420px!important;
				border: 1px solid #e0e0e0;
			}
	
			.el-image {
				width: 100%;
				height: 420px;
			}
		}
	
		.xiaotu {
			width: 18%;
			align-items: center;
			height: 420px;
			overflow-y: auto;
	
			.xiaotu-img {
				cursor: pointer;
				width:100%;
				margin: 0 0 10px 0;
				box-sizing: border-box;
				border: 1px solid #e0e0e0;
	
				&.active {
					border: 3px solid $main-color;
				}
	
				img {
					display: block;
					width: 100%;
					height: 90px;
				}
			}
		}
	}
	
	
	.products-details {
		.nav-left {
			margin: 0 0 10px 0;

			.nav-left-li {
				display: block;
				background: #f4f6fa;
				color: #333;
				padding: 15px 20px;
				overflow: hidden;
				margin: 8px 0 0 0;
				cursor: pointer;

				&:hover {
					background: $main-color;
					color: #fff;

					i {
						color: #fff;
					}
				}

				&.active {
					background: $main-color;
					color: #fff;

					i {
						color: #fff;
					}
				}

				span {
					font-size: 14px;
					float: left;
					width: 80%;
				}

				i {
					float: right;
					color: #999;
				}
			}
		}

		.contact-left {
			margin: 0 0 20px 0;

			.contact-left-banner {
				width: 100%;
			}

			.contact-left-info {
				li {
					background: #f4f6fa;
					padding: 10px 20px;
					display: flex;
					align-items: center;
					margin: 8px 0 0 0;

					img {
						margin: 0 5px 0 0;
					}
				}
			}
		}
		
		.products-info {
			display: flex;
			flex-wrap: wrap;
			justify-content: space-between;
			margin: 0 0 20px 0;

			li {
				display: flex;
				justify-content: space-between;
				background: #f5f5f5;
				padding: 6px 10px;
				box-sizing: border-box;
				margin: 0 0 8px 0;

				&.w100 {
					width: 100%;
				}

				&.w50 {
					width: 49.5%;
				}

				.title {
					display: flex;

					span {
						display: block;
						width: 60px;
						text-align: justify;
						text-justify: distribute-all-lines; // 这行必加，兼容ie浏览器
						text-align-last: justify;
					}
				}

				.content {
					width: calc(100% - 80px);
				}
			}
		}
	}
</style>